// extracted by mini-css-extract-plugin
export default {"tooltip":"zO-z","arrow":"AO-z"};